<template>
  <div
    class="login"
    v-loading.lock="fullscreenLoading"
    element-loading-text="登录中..."
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="log-wrap">
      <div class="left">
        <img src="../../imgs/log_bg.png" alt="" />
      </div>
      <div class="right">
        <h1>欢迎登录</h1>
        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item prop="username">
            <el-input
              style="width: 100%; border: none"
              v-model="loginForm.username"
              placeholder="用户名"
              ><i slot="prefix" class="el-input__icon el-icon-user-solid"></i
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              style="width: 100%"
              :type="type"
              placeholder="密码"
              v-model="loginForm.password"
              @keyup.native.enter="handleKeyDown"
            >
              <i
                v-show="showPwd"
                style="color: blue"
                slot="suffix"
                class="el-input__icon el-icon-view"
                @click="handleShowPwd"
              ></i>
              <i
                v-show="!showPwd"
                slot="suffix"
                class="iconfont icon-yincang"
                @click="handleShowPwd"
              ></i>
              <i slot="prefix" class="el-input__icon el-icon-s-claim"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitForm('loginForm')"
              :loading="loading"
              class="submit_btn"
              :round="true"
            >
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "../../api/api";
import { sha256 } from "@/utilities";

export default {
  name: "login",
  data() {
    return {
      type: "password",
      showPwd: false,
      centerDialogVisible_pwd: false,
      fullscreenLoading: false,
      loading: false,
      ruleForm: {
        pass: "",
        checkPass: "",
        age: "",
      },
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    handleKeyDown() {
      //回车登录
      this.submitForm("loginForm");
    },
    handleShowPwd() {
      this.showPwd = !this.showPwd;
      if (this.showPwd) {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
    async submitForm(formName) {
      this.fullscreenLoading = true;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            let ciphertext=await sha256(this.loginForm.username+"||"+this.loginForm.password);
            const res = await login({
              userNo: this.loginForm.username,
              userPwd: ciphertext,
            });
            if (res.code == 0) {
              //存放token
              // Cookies.set('token',res.data.token);
              sessionStorage.setItem("token", res.data.token);
              sessionStorage.setItem("userName", res.data.userName);
              sessionStorage.setItem("userNo", res.data.userNo);

              setTimeout(() => {
                this.fullscreenLoading = false;
                this.$router.push("/dashed");
                this.$message({
                  type: "success",
                  message: "登录成功",
                });
              }, 500);
            } else {
              setTimeout(() => {
                this.fullscreenLoading = false;
                this.$notify.error({
                  title: "登录提醒",
                  message: res.message,
                  duration: 1500,
                });
                this.loginForm.password = "";
              }, 1000);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          this.fullscreenLoading = false;
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("../../imgs/login_.png");
  background-size: cover;
}
.log-wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  width: 800px;
  height: 480px;
  margin: auto;

  .left {
    width: 380px;
    height: 480px;
    background-image: url("../../imgs/bg.png");
    background-size: cover;

    img {
      // width: 277px;
      // height: 143px;
      display: block;
      margin: 49px auto;
    }
  }

  .right {
    width: 422px;
    height: 480px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 20px;

    h1 {
      margin-top: 106px;
      color: #333;
      font-size: 26px;
      text-align: center;
    }
  }
}

.el-input {
  display: block;
  width: 100%;
  border: none;
  // margin: auto;
}

.btn {
  display: block;
  width: 374px;
  height: 115px;
  margin: auto;
  background-image: url("../../imgs/btn.png");
  background-size: cover;
  border: none;
  outline: none;
}

input {
  display: block;
  // width: 332px;
  height: 30px;
  border: none;
  margin: auto;
  // padding-left: 25px;
  webkit-box-shadow: 0 0 0 1000px white inset;
  /*background: none;*/
  outline: none;

  &.input_username {
    background-image: url("../../imgs/username.png");
    background-position: 0 center;
    background-repeat: no-repeat;
    background-size: 17px 20px;
    border-bottom: 1px solid #5b8fef;
  }
  &.input_password {
    background-image: url("../../imgs/password.png");
    background-position: 0 center;
    background-repeat: no-repeat;
    background-size: 17px 20px;
    border-bottom: 1px solid #5b8fef;
  }
}

.submit_btn {
  display: block;
  width: 100%;
  height: 100px;
  margin: auto;
  background-image: url("../../imgs/btn.png");
  background-size: cover;
  /*background-image: url('../../imgs/btn.png');*/
  background-color: transparent;
  border: none;
}
.el-form-item__error {
  left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue